import styled from "styled-components";

export default styled.div`
  position: relative;
  cursor: pointer;

  .icon-container {
    position: absolute;
    right: -5px;
    bottom: -5px;

    .icon-background {
      border-radius: 100%;
      background-color: white;
    }
  }
`;
